import React from 'react';
import { stopBackgroundScrolling } from 'common/utils/app.utils';

const LoiPopup = ({ setshowPopup, onProceedClick }) => {
  const hidePopup = () => {
    setshowPopup(false);
    stopBackgroundScrolling(false);
  };

  return (
    <div className="drawerSection loi_popup">
      <div className="popup-section cancelOrder">
        <h2>Proceed without Letter Of Intent?</h2>
        <p>The order will require CBH approval since letter of intent is not uploaded.</p>
        <div className="buttonSection">
          <button type="button" className="btn activebtn" onClick={hidePopup}>
            Cancel
          </button>
          <button type="button" className="btn activebtn btn-transparent" onClick={onProceedClick}>
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoiPopup;
